import '../../../../assets/css/screens/serviceprovider/dashboard/bidjobs/BidJobs.css';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import {
  ArrowLeft, CheckCheck
} from 'lucide-react';
import Swal from "sweetalert2";
import MyJobsSkeleton from '../../../../components/JobCardSkeleton';
import echo from '../../../../config/echo';
import UnavailableScreen from '../../../../subscreens/serviceprovider/dashboard/workerdashboard/providerunavailable/UnavailableScreen'
import { statusLabels, TABS } from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/bidjobsconstants/BidJobsConstants';
import DisputeModal from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/disputemodal/DisputeModal';
import ReviewModal from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/reviewmodal/ReviewModal';
import BidModal from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/bidmodal/BidModal';
import OtherBidsModal from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/otherbidsmodal/OtherBidsModals';
import ProofModal from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/proofmodal/ProofModal';
import Lightbox from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/lightbox/LightBox';
import BidJobCard from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/bidjobcard/BidJobCard';

/* ══════════ MAIN ══════════ */
const BidJobs = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [otherBids, setOtherBids] = useState([]);
const [highestBid, setHighestBid] = useState(0);
const [loadingOtherBids, setLoadingOtherBids] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showOtherBids, setShowOtherBids] = useState(false);
const [loading, setLoading] = useState(false);  

  const [activeTab, setActive] = useState('All');
  const [proofFor, setProofFor] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const [replies, setReplies] = useState({});
  const [disputeFor, setDisputeFor] = useState(null);
  const [disputeLoading, setDisputeLoading] = useState(false);
  const [reviews, setReviews] = useState({});
  const [reviewFor, setReviewFor] = useState(null);
  const [jobReviews, setJobReviews] = useState({});
  const [bidModalFor, setBidModalFor] = useState(null);
  const [availability, setAvailability] = useState(
    localStorage.getItem("availability") === "1"
  );
const worker = JSON.parse(localStorage.getItem("worker"));

const currentWorkerId = worker?.id;

console.log("CURRENT WORKER ID:", currentWorkerId);

  const [bids, setBids] = useState([]);

  // view all jobs
const viewallavailablejobs = (showLoader = false) => {

  const authToken = localStorage.getItem("authToken");

  if(showLoader){
    setLoading(true);
  }

  axios.get(`${baseUrl}/worker/viewalljobs`, {
    params: {
      status: activeTab === "All" ? "" : activeTab
    },
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
  .then(res => {

    setBids(res.data.postjobs || []);

    res.data.postjobs.forEach(job => {
      fetchReview(job.id);
    });

  })
  .catch(err => {
    console.log(err.response?.data || err.message);
  })
  .finally(()=>{

    if(showLoader){
      setLoading(false);
    }

  });
};


useEffect(()=>{

 if(availability){
   setLoading(true);
   viewallavailablejobs(true);
 }
 else{
   setLoading(false);
 }

},[availability]);

  //  accept  no biddinh jobs
  const handleAcceptJob = (jobId) => {
    const authToken = localStorage.getItem("authToken");
    axios.post(`${baseUrl}/worker/acceptjob`,
      {
        job_id: jobId
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    )
      .then(res => {

        console.log(res.data);

        // jobs refresh
        viewallavailablejobs();

      })
      .catch(err => {

        if (err.response?.status === 409) {

          alert("Job already assigned");

          viewallavailablejobs();

        }

      })

  }
  // rating and review
  const setReviewField = (id, key, val) =>
    setReviews(prev => ({ ...prev, [id]: { ...(prev[id] || {}), [key]: val } }));

  const handleReview = (jobId) => {
    const authToken = localStorage.getItem('authToken');
    const r = reviews[jobId] || {};
    const job = bids.find(b => b.id === jobId);

    const formData = new FormData();
    formData.append('whpostjob_id', jobId);
    formData.append('workerrating', r.rating);
    formData.append('workerreview', r.text);
    formData.append('whcustomer_id', job?.whcustomer?.id || '');
    formData.append('whserviceprovider_id', job?.whserviceprovider_id || '');

    axios.post(`${baseUrl}/worker/jobreview`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(res => {
        console.log(job);
        console.log(job?.whcustomer);
        console.log(job?.whserviceprovider);
        console.log('Review submitted:', res.data);
        setJobReviews(prev => ({
          ...prev,
          [jobId]: {
            worker: {
              rating: r.rating,
              review: r.text
            }
          }
        }));
        setReviews(prev => ({ ...prev, [jobId]: {} }));
        viewallavailablejobs();
      })
      .catch(err => console.log(err.response?.data || err.message));
  };

  // fetch reviews
  const fetchReview = (jobId) => {

    const authToken = localStorage.getItem('authToken');

    axios.get(`${baseUrl}/worker/viewreview/${jobId}`, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
      .then(res => {


        const workerReview = res.data.worker_review;
        const customerReview = res.data.customer_review;


        setJobReviews(prev => ({
          ...prev,
          [jobId]: {


            // pehle worker check hoga
            worker: {
              rating: workerReview?.workerrating,
              review: workerReview?.workerreview,
            },


            // sirf tab customer show hoga jab worker review kare
            customer: workerReview ? {

              rating: customerReview?.customerrating,
              review: customerReview?.customerreview,

            } : null


          }
        }));

      })

      .catch(err =>
        console.log(err.message)
      );

  };

  // create ticket
  const handleRaiseDispute = ({ category, description }) => {
    const authToken = localStorage.getItem("authToken");
    setDisputeLoading(true);

    const formData = new FormData();

    formData.append("whpostjob_id", disputeFor.id);
    formData.append("customer_id", disputeFor.whcustomer_id);

    formData.append("category", category);
    formData.append("description", description);
    formData.append("raisedby", "worker");
    formData.append("against", "customer");

    axios.post(`${baseUrl}/worker/helpsupport`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        console.log("Dispute Ticket Created:", res.data);

        setDisputeFor(null);

        // refresh jobs → status update (if backend does it)
        viewallavailablejobs();
      })
      .catch((err) => {
        console.log(err.response?.data || err.message);
      })
      .finally(() => {
        setDisputeLoading(false);
      });
  };

  // conversation create
  const createConversation = (job) => {

    const authToken = localStorage.getItem('authToken');

    return axios.post(
      `${baseUrl}/customer/createconversation`,
      {
        job_id: job.id,
        message: job.description
      },
      {
        headers: { Authorization: `Bearer ${authToken}` }
      }
    );
  };

  // start job
  const handleStart = (id) => {
    const authToken = localStorage.getItem("authToken");

    axios.post(`${baseUrl}/worker/startjob`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    )
      .then((res) => {
        console.log("START JOB RESPONSE:", res.data);

        viewallavailablejobs();

      })
      .catch(err => {
        console.log(err.response?.data || err.message);
      });
  };

  const refresh = () => {
    viewallavailablejobs();
  };

  // cancel jobs
  const handleCancel = (id) => {
    const authToken = localStorage.getItem("authToken");

    axios.post(`${baseUrl}/worker/canceljob`,
      { job_id: id },
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    )
      .then((res) => {
        console.log(res.data);
        viewallavailablejobs();
      })
      .catch(err => {
        console.log(err.response?.data || err.message);
      });
  };

  /* ── Open dispute ticket chat ── */
  const openDisputeChat = async (job) => {
    const authToken = localStorage.getItem('authToken');
    console.log(job);
    navigate(`/worker-chat/${job.whconversation?.id}`, {
      state: { description: job.description }
    });
  };

  // worker jobproof
  const handleProof = (files) => {
    const authToken = localStorage.getItem("authToken");

    const formData = new FormData();

    files.forEach(fileObj => {
      formData.append("media[]", fileObj.file);
    });

    formData.append("whpostjob_id", proofFor);

    axios.post(`${baseUrl}/worker/jobproof`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data"
      }
    })
      .then(res => {
        console.log(res.data);

        setProofFor(null);

        viewallavailablejobs();
      })
      .catch(err => {
        console.log(err.response?.data || err.message);
      });
  };

  const handleReply = (id) => {

  };
  const filteredJobs = bids.filter(job => {
    const status = (job.display_status || job.status || '')
      .toString()
      .trim()
      .toLowerCase();

    switch (activeTab.toLowerCase()) {
      case 'all':
        return true;

      case 'pending':
        return status === 'pending';

      case 'bid_sent':
        return status === 'bid_sent';

      case 'assigned':
        return status === 'assigned';

      case 'in_progress':
        return status === 'in_progress';

      case 'awaiting_confirmation':
        return status === 'awaiting_confirmation';

      case 'completed':
        return status === 'completed';

      case 'rejected':
        return status === 'rejected';

      case 'cancelled':
        return status === 'cancelled';

      case 'raise_dispute':
        return status === 'raise_dispute';

      default:
        return true;
    }
  });
  const handleBidSubmit = (jobId, bidAmount, message, onDone) => {

    const start = Date.now();

    const authToken = localStorage.getItem("authToken");

    const formData = new FormData();
    formData.append("message", message);
    formData.append("bidAmount", bidAmount);
    formData.append("whpostjob_id", jobId);

    console.log("Bid API Started");

    axios.post(`${baseUrl}/worker/placebid`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then(res => {

        console.log("Bid API Time:", Date.now() - start, "ms");

   

        onDone?.();

      })
      .catch(err => {

        console.log("Bid API Time:", Date.now() - start, "ms");

        const errorMessage = err.response?.data?.message;

        if (errorMessage === "Your bid limit has been reached.") {

          Swal.fire({
            title: "Bid Limit Reached!",
            text: "Your bidding limit has been reached. Upgrade your plan to place more bids.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Upgrade Plan",
            cancelButtonText: "Later",
            timer: 5000,
            timerProgressBar: true,
          }).then((result) => {

            if (result.isConfirmed) {
              navigate("/worker/subscription");
            }

          });

        }
        else if (errorMessage === "You need an active subscription to place a bid.") {

          Swal.fire({
            title: "Subscription Required!",
            text: "Please subscribe to a plan before placing a bid.",
            icon: "info",
            confirmButtonText: "View Plans"
          }).then((result) => {

            if (result.isConfirmed) {
              navigate("/worker/subscription");
            }

          });

        }
        else {

          // Swal.fire({
          //   title: "Error!",
          //   text: errorMessage || "Something went wrong while placing bid.",
          //   icon: "error",
          //   timer: 3000,
          //   showConfirmButton: false
          // });

        }

        onDone?.();

      });
  };

// view other bids
const fetchOtherWorkerBids = async (jobId) => {

  const authToken = localStorage.getItem("authToken");

  try {

    setLoadingOtherBids(true);
const res = await axios.get(
  `${baseUrl}/worker/viewotherbids/${jobId}`,
  {
    headers:{
      Authorization:`Bearer ${authToken}`
    }
  }
);

   console.log("Other Bids API Response:", res.data);
console.log("Bids:", res.data.bids);

setOtherBids(res.data.bids || []);
setHighestBid(res.data.highest_bid || 0);

    return true;

  } catch (err) {

    console.log(err.response?.data || err.message);
    return false;

  } finally {

    setLoadingOtherBids(false);

  }
};


// 👇 Yahan lagana hai
const openOtherWorkerBids = async (job) => {

  const ok = await fetchOtherWorkerBids(job.id);

 

  setSelectedJob(job);
  setShowOtherBids(true);

};


// sockets
useEffect(()=>{

if(!currentWorkerId) return;


const channel = echo.channel(
 `worker-${currentWorkerId}`
);


channel.listen(".JobStatusUpdated", (event) => {
    console.log("SOCKET EVENT RECEIVED:", event);

    viewallavailablejobs();
});


return ()=>{
 echo.leave(`worker-${currentWorkerId}`);
}


},[currentWorkerId]);



return (
<>
{
loading ? (
   <MyJobsSkeleton />
) : (

<div className="aj-page">

        <div className="aj-header">
          <button className="aj-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={22} /></button>
          <h2 className="aj-title">Bid Jobs</h2>
        </div>
        {!availability ? (
          <UnavailableScreen
            availablity={availability}
            setAvailability={setAvailability}
          />
        ) : (
          <>
            <div className="aj-tabs">
              {TABS.map(t => {
                const count =
                  t === 'All'
                    ? bids.length
                    : bids.filter(
                      b => (b.display_status || b.status || '').toLowerCase() === t.toLowerCase()
                    ).length;

                return (
                  <button
                    key={t}
                    className={'aj-tab' + (activeTab === t ? ' aj-tab--active' : '')}
                  onClick={() => {
   setActive(t);
   viewallavailablejobs(false);
}}
                  >
                    {t === 'All' ? 'All' : (statusLabels[t] || t)}
                    <span className="aj-tab__count">
                      {count}
                    </span>
                  </button>
                );
              })}
            </div>

            <div className="aj-list">
              {bids.length === 0 ? (
                <div className="aj-empty"><CheckCheck size={42} /><p>No bids in this state</p></div>
              ) : filteredJobs.map((b, i) => {
                // console.log("JOB STATUS => ", b.status);
                return (
                  <BidJobCard
                    key={b.id}
                    b={b}
                    i={i}
                    jobReviews={jobReviews}
                    reviews={reviews}
                    replies={replies}
                    setReplies={setReplies}
                    setLightbox={setLightbox}
                    setProofFor={setProofFor}
                    setDisputeFor={setDisputeFor}
                    setReviewFor={setReviewFor}
                    setBidModalFor={setBidModalFor}
                    handleStart={handleStart}
                    handleCancel={handleCancel}
                    handleBidSubmit={handleBidSubmit}
                    handleReply={handleReply}
                    viewallavailablejobs={viewallavailablejobs}
                    handleAcceptJob={handleAcceptJob}
                    currentWorkerId={currentWorkerId}
                    openOtherWorkerBids={openOtherWorkerBids}
                    setSelectedJob={setSelectedJob}

                  />
                );
              })}
            </div>


            {bidModalFor && (
              <BidModal
                jobId={bidModalFor}
                onClose={() => setBidModalFor(null)}
                onSubmit={handleBidSubmit}
              />
            )}

        {showOtherBids && selectedJob && (
  <OtherBidsModal
    bids={otherBids}
    highestBid={highestBid}
    loading={loadingOtherBids}
    onClose={() => {
        setShowOtherBids(false);
        setSelectedJob(null);
        setOtherBids([]);
        setHighestBid(0);
    }}
    onPlaceBid={() => {
        setShowOtherBids(false);
        setBidModalFor(selectedJob.id);
    }}
/>
)}

            {proofFor &&
              <ProofModal
  onClose={() => setProofFor(null)}
  onSubmit={(files)=>{
      handleProof(files);
      setDisputeFor(null);
  }}
/>
              }

            {reviewFor && (
              <ReviewModal
                onClose={() => setReviewFor(null)}
                jobId={reviewFor}
                reviewData={reviews[reviewFor]}
                onReviewChange={setReviewField}
                onSubmit={(jobId) => {
                  handleReview(jobId);
                  setReviewFor(null);
                }}
              />
            )}

            {disputeFor && (
              <DisputeModal
                onClose={() => setDisputeFor(null)}
                onSubmit={handleRaiseDispute}
                loading={disputeLoading}
              />
            )}

            <Lightbox item={lightbox} onClose={() => setLightbox(null)} />

          </>
        )}
    </div>
)
}
</>
)
};
export default BidJobs;